import { render } from "./BovineEdit.vue?vue&type=template&id=7b415d09"
import script from "./BovineEdit.vue?vue&type=script&lang=js"
export * from "./BovineEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__